import { createAction } from "redux-actions";
import * as dbSubActions from "./DbSubscriptionActions";
import { Thunk } from "./Thunk";
import { ErrorCodes } from "../domain";
import { Page, PageStateStatus } from "../models/page";
import { Api } from "../services/Api";

/** The interval timer keeping track of when to request page data */
let requestTimer: NodeJS.Timer | undefined;

/** The timer for how long the app to wait before reloading the page data */
const expectedRefetchTimer: NodeJS.Timer | undefined = undefined;

const prefix = "PAGE_";

export class Constants {
    public static PAGE_LOADED = prefix + "PAGE_LOADED";
    public static PAGE_STATUS_UPDATE = prefix + "PAGE_STATUS_UPDATE";
    public static PAGE_SUBSCRIBED = prefix + "PAGE_SUBSCRIBED";
    public static PAGE_UPDATED = prefix + "PAGE_UPDATED";
}

export type PageStatusUpdatePayload = PageStateStatus;

export const loadPage = (pageId: number): Thunk => async (dispatch, getState) => {
    const qp = { queryParams: { pageId }};
    const result = await new Api(getState()).get<Page>(Api.endpoints.page.page, qp);

    // console.log("page loaded?", result);

    if (result.isSuccess && result.data) {
        const page = result.data;
        const subscribedIds = getState().page.subscribedIds;

        // check if subscribed to db updates
        if (subscribedIds.findIndex((x) => x !== undefined && page !== undefined && x === pageId) === -1)
            await dispatch(dbSubActions.subscribeToPage(page.id));

        // trigger page loaded action
        await dispatch(onPageLoaded(page));
    }
    else {
        // page not found or error
        await dispatch(onPageStatusUpdate({
            id: pageId,
            loading: false,
            found: result.errorCode !== ErrorCodes.NotFound.id,
            errors: result.errors,
        }));
    }
};

/**
 * Starts the timer of when the app expects page to be reloaded
 */
// export const startExpectedRefetchTimer = (): Thunk => async (dispatch, getState) => {
//     if (expectedRefetchTimer !== undefined)
//         clearTimeout(expectedRefetchTimer);

//     expectedRefetchTimer = setTimeout(() => {
//         console.warn("We expected page to be reloaded by socket. But it didn't happen, so let's force reload it.");
//         // dispatch(requestNavigation(false));
//         dispatch(AdminNavListActions.loadData());
//     }, 10000);
// };

export const resetDbSubscriptions = (): Thunk => (dispatch, getState) => {
    getState().page.subscribedIds.forEach(async (id) => {
        if (id) {
            console.log("Resetting subscription for page", id);
            await dispatch(dbSubActions.subscribeToPage(id));
        }
    });
};

/**
 * Starts the timer to request page.
 */
export const startReqestPageTimer = (pageId: number): Thunk => async (dispatch, getState) => {
    if (requestTimer !== undefined)
        clearTimeout(requestTimer);

    requestTimer = setTimeout(() => {
        // dispatch(requestNavigation(false));
        dispatch(loadPage(pageId));
        if (expectedRefetchTimer !== undefined)
            clearTimeout(expectedRefetchTimer);
    }, 375);
};

export const onPageLoaded = createAction<Page, Page>(
    Constants.PAGE_LOADED, (page) => (page),
);

export const onPageSubscribed = createAction<number, number>(
    Constants.PAGE_SUBSCRIBED, (pageId) => (pageId),
);

export const onPageStatusUpdate = createAction<PageStatusUpdatePayload, PageStatusUpdatePayload>(
    Constants.PAGE_STATUS_UPDATE, (status) => (status),
);



// WEBPACK FOOTER //
// ./src/actions/PageActions.ts